





































// Retrofitted from:
// https://github.com/graphql/graphql-playground/blob/60f90a910f6df590c6c87cf3f8922a4f61ef454e/packages/graphql-playground-react/src/components/Playground/ResponseTracing.tsx

import Vue from 'vue';
import TracingRow from './TracingRow.vue';

export default Vue.extend({
  name: 'Tracing',
  components: {
    TracingRow,
  },
  props: {
    tracing: {
      type: Object,
    },
    startTime: {
      type: Number, // in ms
      default: 0,
    },
    endTime: {
      type: Number, // in ms
      default: 0,
    },
  },
  computed: {
    tracingSupported(): boolean {
      return !!this.tracing && !!this.startTime && !!this.endTime;
    },
    requestDuration(): number {
      return this.startTime ? Math.abs(new Date(this.tracing.startTime).getTime() - this.startTime) : 0;
    },
    responseDuration(): number {
      return this.endTime ? Math.abs(new Date(this.tracing.endTime).getTime() - this.endTime) : 0;
    },
    requestDurationNanoseconds(): number {
      return this.requestDuration * 1000 * 1000;
    },
    responseDurationNanoseconds(): number {
      return this.requestDurationNanoseconds + this.tracing.duration;
    },
    resolvers(): any[] {
      return this.tracing.execution.resolvers;
    },
  },
});
